<template>
  <section class="content">
    <vue-headful :title="`QB-STATISTICS | ${pageInfo.name}`"></vue-headful>
    <div class="box" ref="box">
      <div class="box-header" ref="boxHeader">
        <h3 class="box-title"><template v-if="loading"><i class="fa fa-spinner fa-spin"></i></template><template v-else>{{pageInfo.name}}</template></h3>
        <div class="box-tools">
          <div class="btn-group">
            <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
          </div>
        </div>
      </div>
      <div class="box-body" ref="boxBody" v-show="!loading">
      </div>
      <div class="box-body" v-show="loading">
        <div class="row text-center">
          <i class="fa fa-spinner fa-spin fa-3x"></i>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Vue from 'vue'
import Filters from '../components/Filters'
import Api from '@/services/Api'
import BarChart from '../components/BarChart'
import LineChart from '../components/LineChart'
import PieChart from '../components/PieChart'
import DataTable from '../components/DataTable'
import { bus } from "../main";

const Components = [
  {
    name: 'Filters',
    template: Filters
  },
  {
    name: 'BarChart',
    template: BarChart
  },
  {
    name: 'LineChart',
    template: LineChart
  },
  {
    name: 'PieChart',
    template: PieChart
  },
  {
    name: 'DataTable',
    template: DataTable
  }
]
export default {
  name: 'ShellComponent',
  data() {
    return {
      modules: [],
      alerts: [],
      loading: false,
      pageInfo: {}
    }
  },
  mounted() {
    this.$nextTick(this.renderPage())
  },
  methods: {
    renderPage () {
      bus.$off('updatedFilters')
      bus.$emit('clearAlerts')
      this.loading = true
      this.$refs.boxBody.innerHTML = ''
      let instance
      let ComponentClass
      Api().get(`/frontend/navigation/page?id=${this.$store.state.activePage}`)
        .then(res => {
          this.pageInfo = res.data
          this.modules = res.data.modules
          this.modules.forEach(m => {
            let c = Components.find(c => {return c.name === m.component})
            ComponentClass = Vue.extend(c.template)
            instance = new ComponentClass({
              propsData: {endpoint: m.endpoint, config: m.config, pageInfo: this.pageInfo, moduleIndex: this.modules.indexOf(m)}
            })
            instance.$mount()
            this.$refs.boxBody.appendChild(instance.$el)
            if (this.modules.length > 1 && this.modules.indexOf(m) !== this.modules.length -1) {
              let hr = document.createElement('hr')
              this.$refs.boxBody.appendChild(hr)
            }
          })
          this.loading = false
        })
      .catch(error => {
        this.$notify({
          group: 'foo',
          type: 'error',
          title: 'Error',
          text: 'Es gab ein Fehler'
        });
      })
    }
  },
  watch: {
    $route (to, from) {
      if (to.path !== from.path) {
        this.renderPage()
      }
    }
  }
}
</script>
<style>

</style>
